import { Injectable, inject } from '@angular/core';
import { UpdateAssetFindDialogComponent } from './update-asset-find-dialog.component';
import { DialogService } from '@core/services/dialog.service';
import {
  FindUpdateAction,
  FindUpdateDialogType,
} from '@pages/assets-page/components/constants';
import { AssetFindUpdateDialogData } from '@pages/assets-page/components/interfaces';
import { DvDialogComponent } from '@devinco/ui/dds';

@Injectable({ providedIn: 'root' })
export class UpdateAssetFindDialogService {
  private dialog = inject(DialogService);

  openAssetFindUpdateDialog(
    dialogType: FindUpdateDialogType,
    serial?: number
  ): DvDialogComponent<
    AssetFindUpdateDialogData,
    UpdateAssetFindDialogComponent
  > {
    return this.dialog.open<
      AssetFindUpdateDialogData,
      UpdateAssetFindDialogComponent
    >({
      size: 'md',
      type: 'error',
      hideFooter: true,
      contentComponent: UpdateAssetFindDialogComponent,
      title:
        dialogType === FindUpdateDialogType.DeleteDialog
          ? 'Asset.DeleteDialog.Title'
          : 'Asset.UpdateFindDialog.Title',
      confirmText:
        dialogType === FindUpdateDialogType.DeleteDialog
          ? 'General.Delete'
          : 'General.Confirm',
      cancelText: 'General.Cancel',
      data: { dialogType, serial },
    });
  }

  getFindUpdateQueryParams(action: FindUpdateAction): string {
    switch (action) {
      case FindUpdateAction.DeactivateFind:
        return 'option=deactivate';
      case FindUpdateAction.DeleteFind:
        return 'option=delete';
      default:
        return '';
    }
  }
}
